import { useSelector } from 'react-redux';
import { InputLabel, Switch, FormLabel, Modal, CircularProgress, Typography } from '@material-ui/core';
import { useMutation } from '@tanstack/react-query';
import styled from 'styled-components';

import { checkIsFlagAllowed } from '../../apis/white-label-applications.ts';
import { ColumnWithGap } from '../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';

const FEATURE_FLAGS = [
  { value: 'clinic', label: 'Clinic', defaultValue: false },
  { value: 'consultations', label: 'Pharmacy First', defaultValue: true },
  { value: 'services', label: 'Services', defaultValue: true },
  { value: 'pharmacy_shop', label: 'Shop', defaultValue: true },
]; // TODO: fetch from API

export default function FeatureFlags({ onChange, whiteLabelUpdatePayload }) {
  const { whiteLabelApp } = useSelector(state => state.organisations);

  const { mutateAsync: isFlagAllowed, isLoading: isCheckingIfFlagIsAllowed } = useMutation({
    mutationFn: (flag) => checkIsFlagAllowed({ whiteLabelAppId: whiteLabelApp._id, flag }),
  });

  async function handleFlagChange(flag, checked) {
    if (checked) {
      const isFlagAllowedToBeSwitchedOn = await isFlagAllowed(flag);
      if (!isFlagAllowedToBeSwitchedOn) return;
    }

    onChange(flag, checked);
  }

  function isChecked(flag, { whiteLabelUpdatePayload, whiteLabelApp, defaultValue }) {
    if (typeof whiteLabelUpdatePayload?.feature_flags?.[flag] === 'boolean') {
      return whiteLabelUpdatePayload.feature_flags[flag];
    }

    if (typeof whiteLabelApp?.feature_flags?.[flag] === 'boolean') {
      return whiteLabelApp.feature_flags[flag];
    }

    return defaultValue;
  }

  return (
    <ColumnWithGap>
      <InputLabel>Feature flags</InputLabel>
      {FEATURE_FLAGS.map(({ value, label, defaultValue }) => {
        const checked = isChecked(value, { whiteLabelUpdatePayload, whiteLabelApp, defaultValue });

        return (
          <div key={value}>
            <FormLabel>{label}</FormLabel>
            <Switch
              name={value}
              checked={checked}
              onChange={(e, checked) => handleFlagChange(value, checked)}
            />
          </div>
        );
      })}
      <Modal open={isCheckingIfFlagIsAllowed}>
        <LoadingBox text="Checking if flag is allowed" />
      </Modal>
    </ColumnWithGap>
  );
}

function LoadingBox({ text }) {
  return <Box tabIndex={-1}>
    <CircularProgress color='primary' />
    <Typography variant='body1'>{text}</Typography>
  </Box>
}

const Box = styled.div`
  width: 50%;
  max-width: 400px;
  background-color: white;
  padding: 30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
